import { render, staticRenderFns } from "./classReport.vue?vue&type=template&id=60869e50&scoped=true&"
import script from "./classReport.vue?vue&type=script&lang=js&"
export * from "./classReport.vue?vue&type=script&lang=js&"
import style0 from "./classReport.vue?vue&type=style&index=0&id=60869e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60869e50",
  null
  
)

export default component.exports